import { Injectable } from '@angular/core';
import { MechanicsService } from './mechanics.service';
import { instanceType } from '../utils';
import { SearchService } from './search.service';

// the defaults if none in the localstorage
const prefsDefaults: any = {

	similarlogo: {
		layout: 'gallery',
		rows: '60',
		sort: 'score desc',
		filters: 'o',
		niceClassOrder : "label2" // corresponds to relevance
	},
	similarname: {
		layout: 'list',
		rows: '30',
		sort: 'score desc',
		filters: 'o',
		niceClassOrder : "label2" // corresponds to relevance
	},
	advancedsearch : {
		layout: 'list',
		rows: '30',
		sort: 'score desc',
		filters: 'o', // o - opened, c - collapsed
	},
	graphs: {
		rows: '0',
		chart: 'designation'
	},
	explore: {
		rows: '30',
		layout: 'list',
		sort: 'applicationDate desc',
		filters: 'c'
	},
	brand: {

	},
	reports: {
		layout: 'list'
	},
	all : {
		dateFormat : "yy-mm-dd"
	}
}


@Injectable({
	providedIn: 'root'
})
export class PreferencesService {

	public preferences: any;
	public hasValidToken: boolean = false;

	constructor(private ms: MechanicsService,
				private ss: SearchService) {
		this.loadPreferences(this.hasValidToken);
	}

	async storePreferences() {

		const l = `storePreferences() - `;

		// serialize and store preferences for the page in local storage

		// Little hack to give Angular some time for ngModel to reflect in preferences
		await new Promise(resolve => setTimeout(resolve));

		// PL: operations on local storage are synchronous
		localStorage.setItem(
			`${instanceType()}.preferences`,
			JSON.stringify(this.preferences)
		);

		const localPrefsStr: string = localStorage.getItem(`${instanceType()}.preferences`);
		let localPrefs;
		try {
			localPrefs = JSON.parse(localPrefsStr);
		} catch (err) {
			console.error("Failed to find local preferences in LocalStorage, or could not parse them");
		}

		// store preferences remotely, if authenticated
		await this.syncToDynamoDB();
	}

	async loadPreferences(tokenStatus: boolean): Promise<void> {

		const l = `loadPreferences() - `

		this.hasValidToken = tokenStatus;

		// First grab the remote preferences from remote
		let remotePreferences; 
		if (this.hasValidToken) {
			try {
				remotePreferences = await this.ss.getPersist('preferences');
				remotePreferences = remotePreferences[0]['payload'];
				if (Array.isArray(remotePreferences) || remotePreferences.length == 0) {
					remotePreferences = null;
				}
			} catch (err) {
				console.error(`${l}Failed to find preferences in persistent storage, or could not decompress or parse them`);
				remotePreferences = null;
			}
		}
		
		// deserialize the preferences from local storage if present
		const localPrefsStr: string = localStorage.getItem(`${instanceType()}.preferences`);
		let localPrefs;
		if (localPrefsStr && localPrefsStr !== "[]") {
			try {
				localPrefs = JSON.parse(localPrefsStr);
			} catch (err) {
				console.error("Failed to find local preferences in LocalStorage, or could not parse them");
				localPrefs = null;
			}
		}

		// would we really need to merge these remote and local json ? likely no
		// we simply priorize the remote ones when available

		if (remotePreferences) {
			this.preferences = remotePreferences;
		}
		else if (localPrefs) {
		 	this.preferences = localPrefs;
		}
		else {
		 	this.preferences = prefsDefaults;
		}

		// prefs init and checks
		for (let key of Object.keys(prefsDefaults)) {
			this.preferences[key] = Object.assign({}, prefsDefaults[key], (this.preferences[key] || {}));
		}

		// Just in case it was modified/updated by the thorough check above, so we're up to date in the LS
		this.storePreferences(); 
	}

	get currentPrefs(){
		return this.preferences[this.ms.endpoint];
	}

	getPref(which: string, endpoint: string = this.ms.endpoint): string { 
		// Utility to easily get any preference, for instance from a template. ps.getPref('layout') == 'grid'

		const l: string = `PS getPref() - `;

		// console.log(`${l}this.ms.endpoint = '${this.ms.endpoint}' - typeof this.ms.endpoint = '${typeof this.ms.endpoint}'`);

		if (!endpoint) {
			// console.log(`${l}'this.ms.endpoint' is undefined (yet), the page is probably still loading. Skipping for now`);
			return null;
		}

		//if (!this.preferences)
		//	await this.loadPreferences();

		if (!this.preferences[endpoint]) {
			// console.log(`${l}this.preferences[${endpoint}] is undefined, attempting to load some default value`);
			this.preferences[endpoint] = prefsDefaults[endpoint] || {}
			// console.log(`${l}this.preferences[${endpoint}] is now = `, this.preferences[endpoint]);
			this.storePreferences();
		}

		try {
			return this.preferences[endpoint][which];
		} catch (err) {
			console.error(`${l}Could not return preferences[${endpoint}][${which}] : endpoint='${endpoint}' - which='${which}''`);
			return "";
		}
	}

	async setPref(which: string, value: any, endpoint: string = this.ms.endpoint) {

		const l: string = `PS setPref() - `
		if (!endpoint) {
			console.log(`${l}'this.ms.endpoint' is undefined (yet), the page is probably still loading. Skipping for now`);
			return null;
		}
		this.preferences[endpoint] = this.preferences[endpoint] || {};
		this.preferences[endpoint][which] = value
		this.storePreferences();
	}

	async syncToDynamoDB(): Promise<void> {
		// if user is not authenticated, nowhere to remotely save the pref
		if (!this.hasValidToken)
			return;

		// Save the content of local storage to DynamoDB  
		const l = `PS synctoDynamoDB() - `;

		const localPreferencesStr: string = localStorage.getItem(`${instanceType()}.preferences`);
		let preferencesReports: string;

		if (localPreferencesStr && localPreferencesStr !== "[]") {
			try {
				preferencesReports = JSON.parse(localPreferencesStr);

				let body = {
					payload: preferencesReports,
					name: 'preferences'
				};

				await this.ss.postPersist('preferences', body);
			}
			catch (err) {
				console.error(`${l}DynamoDB sync error = `, err);
			}
		}
	}
}
